<script lang="ts">
import { defineComponent, computed } from 'vue';
import { any, object, oneOf } from 'vue-types';

export interface AmericanAddressProps {
  address1: string;
  address2?: string;
  address_city: string;
  address_state: string;
  address_zip: string;
  address_country: string;
}

export type AddressProps = Omit<AmericanAddressProps, 'address_state' | 'address_zip' | 'address_city'> & {
  address_city?: string;
  address_state?: string;
  address_zip?: string;
}

export default defineComponent({
  name: 'AddressText',
  props: {
    record: object<AddressProps>().isRequired,
    layout: oneOf(['horizontal', 'vertical']).def('horizontal'),
    class: any(),
  },
  setup(props) {
    const isEmpty = computed(() => !props.record.address1);
    return {
      isEmpty,
    };
  },
});
</script>

<template>
  <span v-if="isEmpty" />
  <div
    v-else
    :class="[
      $props.class,
      {
        'flex flex-col': layout === 'vertical',
      },
    ]"
    data-test-id="address"
  >
    <span>
      {{ record.address1 }}<span v-if="layout !== 'vertical'">, </span>
    </span>
    <span v-if="record.address2">
      {{ record.address2 }}<span v-if="layout !== 'vertical'">, </span>
    </span>
    <span>
      <template v-if="record.address_city">
        {{ record.address_city }},
      </template>
      {{ record.address_state }}
      {{ record.address_zip }}
      {{ record.address_country }}
    </span>
  </div>
</template>
